import { QUOTE_CHART_DATE_SELECT_FILTER } from 'static/chart';
import { DateFilter, PriceChartParams } from 'types/chart';
import dayjs from 'dayjs';

export const getDateFilterLabelByValue = (value: DateFilter) => {
  const filter = QUOTE_CHART_DATE_SELECT_FILTER.find(
    (item) => item.value === value,
  );
  return filter ? filter.label : null; // 값을 찾지 못하면 null 반환
};

export const getDateRangeForFilter = (
  filter: DateFilter,
): Omit<PriceChartParams, 'areaInPyeong' | 'complexId' | 'tradeType'> => {
  const currentDate = dayjs();
  const oneDayAgo = currentDate.subtract(1, 'day').format('YYYY-MM-DD');
  const oneMonthAgo = currentDate.subtract(1, 'month').format('YYYY-MM-DD');
  const threeMonthAgo = currentDate.subtract(3, 'month').format('YYYY-MM-DD');
  const sixMonthAgo = currentDate.subtract(6, 'month').format('YYYY-MM-DD');
  const oneYearAgo = currentDate.subtract(1, 'year').format('YYYY-MM-DD');
  const threeYearAgo = currentDate.subtract(3, 'year').format('YYYY-MM-DD');

  switch (filter) {
    case 'ONE_MONTH':
      return {
        startDate: oneMonthAgo,
        endDate: oneDayAgo,
      };
    case 'THREE_MONTH':
      return {
        startDate: threeMonthAgo,
        endDate: oneDayAgo,
      };
    case 'SIX_MONTH':
      return {
        startDate: sixMonthAgo,
        endDate: oneDayAgo,
      };
    case 'ONE_YEAR':
      return {
        startDate: oneYearAgo,
        endDate: oneDayAgo,
      };
    case 'THREE_YEAR':
      return {
        startDate: threeYearAgo,
        endDate: oneDayAgo,
      };
    default:
      return {
        startDate: oneMonthAgo,
        endDate: oneDayAgo,
      };
  }
};

export const getIsVisibleDay = ({
  startDate,
  endDate,
}: Pick<PriceChartParams, 'startDate' | 'endDate'>) => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const isVisibleDay = end.diff(start, 'day') <= 93;

  return isVisibleDay;
};

export const filterZeroAndGetMin = (values: number[]): number => {
  const filteredValues = values.filter((value) => value !== 0);
  return filteredValues.length ? Math.min(...filteredValues) : 0;
};

export const filterZeroAndGetMax = (values: number[]): number => {
  const filteredValues = values.filter((value) => value !== 0);
  return filteredValues.length ? Math.max(...filteredValues) : 0;
};
